export const lightPurple50 = "#f2ebfb";
export const lightPurple100 = "#ede1fa";
export const lightPurple200 = "#dcc3f5";
export const lightPurple300 = "#caa6f0";
export const lightPurple400 = "#b988eb";
export const lightPurple500 = "#a86be6";
export const lightPurple600 = "#925be0";
export const lightPurple700 = "#7e4cda";
export const lightPurple800 = "#693cd4";
export const lightPurple900 = "#542dcf";
export const lightPurple1000 = "#3712ba";
export const lightPurpleA100 = "#edc0fa";
export const lightPurpleA200 = "#d3a0f2";
export const lightPurpleA400 = "#7c35d9";
export const lightPurpleA500 = "#3708c6";
export const lightPurpleA1000 = "#3a2550";
